import EcoTabSwiper from 'eco-design/sections/eco-tab-swiper';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import CardInfoBtn from './CardInfoBtn';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.TabSwiperA');

    return (
        <div className={styles.comp} id="TabSwiperA">
            <EcoSpace />
            <EcoSection title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <EcoTabSwiper
                items={[
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745744254399/Kitchen.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745744254399/Kitchen.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745744253535/Kitchen%20(1).jpg',
                        tabLabel: t('tab1'),
                        tabValue: 'A1',
                        moreBtnContent: (
                            <>
                                <CardInfoBtn className="a1" text={t('item1_t1')} desc={t('item1_d1')} />
                                <CardInfoBtn className="a2" text={t('item1_t2')} desc={t('item1_d2')} />
                                <CardInfoBtn className="a3" text={t('item1_t3')} desc={t('item1_d3')} />
                                <CardInfoBtn className="a4" text={t('item1_t4')} desc={t('item1_d4')} />
                            </>
                        ),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745744255400/Living%20Room.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745744255400/Living%20Room.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745744253771/living%20room%20(1).jpg',
                        tabLabel: t('tab2'),
                        tabValue: 'A2',
                        moreBtnContent: (
                            <>
                                <CardInfoBtn className="b1" text={t('item2_t1')} desc={t('item2_d1')} />
                                <CardInfoBtn className="b2" text={t('item2_t2')} desc={t('item2_d2')} />
                                <CardInfoBtn
                                    className="b3"
                                    text={t.rich('item2_t3', {
                                        i: (v) => `${v}'`,
                                    })}
                                    desc={t.rich('item2_d3', {
                                        i: (v) => `${v}'`,
                                    })}
                                />
                                <CardInfoBtn className="b4" text={t('item2_t4')} desc={t('item2_d4')} />
                            </>
                        ),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745744254081/Laundry%20Room.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745744254081/Laundry%20Room.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745744254205/Laundry%20Room%20(1).jpg',
                        tabLabel: t('tab3'),
                        tabValue: 'A3',
                        moreBtnContent: (
                            <>
                                <CardInfoBtn className="c1" text={t('item3_t1')} desc={t('item3_d1')} />
                                <CardInfoBtn className="c2" text={t('item3_t2')} desc={t('item3_d2')} />
                                <CardInfoBtn className="c3" text={t('item3_t3')} desc={t('item3_d3')} />
                            </>
                        ),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745744254627/Yard.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745744254627/Yard.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745744254825/Yard%20(1).jpg',
                        tabLabel: t('tab4'),
                        tabValue: 'A4',
                        moreBtnContent: (
                            <>
                                <CardInfoBtn className="d1" text={t('item4_t1')} desc={t('item4_d1')} />
                                <CardInfoBtn className="d2" text={t('item4_t2')} desc={t('item4_d2')} />
                                <CardInfoBtn className="d3" text={t('item4_t3')} desc={t('item4_d3')} />
                                <CardInfoBtn className="d4" text={t('item4_t4')} desc={t('item4_d4')} />
                            </>
                        ),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745744255054/Office.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745744255054/Office.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745744255242/office%20(1).jpg',
                        tabLabel: t('tab5'),
                        tabValue: 'A5',
                        moreBtnContent: (
                            <>
                                <CardInfoBtn className="e1" text={t('item5_t1')} desc={t('item5_d1')} />
                                <CardInfoBtn className="e2" text={t('item5_t2')} desc={t('item5_d2')} />
                                <CardInfoBtn className="e3" text={t('item5_t3')} desc={t('item5_d3')} />
                                <CardInfoBtn className="e4" text={t('item5_t4')} desc={t('item5_d4')} />
                            </>
                        ),
                    },
                ]}
            />
        </div>
    );
}
